import React from 'react'
import { Carousel } from '@material-tailwind/react'

type CarouselProps = {
  children: React.ReactNode
  classname?: string
  autoPlay?: boolean
}

export const CarouselComponent: React.FC<CarouselProps> = ({
  children,
  classname = '',
  autoPlay = true,
}) => (
  <Carousel
    className={`rounded-xl no-scrollbar ${classname}`}
    autoplay={autoPlay}
    loop={autoPlay}
  >
    {children}
  </Carousel>
)
